export default __webpack_public_path__ + "static/media/14.72869ed8.jpg";